import React from "react";
import ReactDOM from "react-dom";

import { observer, inject, Provider } from "mobx-react";
import { extendObservable } from 'mobx';

import Quantity    from './Quantity'

@inject('core')
@observer
export default class QuantityList extends React.Component {
	
	componentDidMount() {
		const { core } = this.props
		
		this.changeNeeds = this.changeNeeds.bind(this)
	}
	
	changeNeeds(product_id, change_delta) {
		const { core } = this.props

		core.action({ op: 'setNeeds', product_id: product_id, needs: core.products.find( p => p.product_id == product_id ).needs + change_delta })
	}

	render() {
		const { core } = this.props
		
		const productList = core.products.slice().sort((a, b) => a.name.localeCompare(b.name)).map((product) => {
			return <div key={product.product_id}>
				<Quantity product_id={product.product_id} />
			</div>
		})
		
		return <div>
		{productList}
		</div>
	}
	
}


